import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as CpuImg } from "../../../img/ico-vpc-list-cpu.svg";
import { ReactComponent as MemoryImg } from "../../../img/ico-vpc-list-memory.svg";
import { ReactComponent as StorageImg } from "../../../img/ico-vpc-list-storage.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";

import HostAdd from "./HostAdd";
import HostUpdate from "./HostUpdate";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import InstanceTypeUpdate from "./HostUpdate";
import { t } from "i18next";
import CustomProgressBar from "../../base/CustomProgressBar";





interface HostAvailityZoneData {
    availability_zone_id: string;
    availability_zone_name: string;
    availability_zone_active_yn: boolean;
    create_ts: string;
    update_ts: string;
}


interface HostClustersData {
    host_cluster_id: string;
    host_cluster_name: string;
    host_cluster_type_code: string;
    create_ts: string;
    update_ts: string;
    availability_zone: HostAvailityZoneData;
}


export interface HostMgmtData {
    host_id: string;
    host_desc: string;
    host_name: string;
    hypervisor_name: string;
    host_status_code: string;
    ip_address: string;
    deploy_ip_address: string;
    cpu_arch: string;
    cpu_vendor: string;
    cpu_model: string;
    cpu_socket_count: number;
    cpu_core_count: number;
    cpu_thread_count: number;
    up_yn: boolean;
    vcpu_total_count: number;
    vcpu_used_count: number;
    memory_total_capacity_mb: number;
    memory_used_capacity_mb: number;
    gpu_total_count: number;
    gpu_used_count: number;
    local_storage_total_capacity_gb: number;
    local_storage_used_capacity_gb: number;
    vm_count: number;
    create_ts: string;
    update_ts: string;

    region: {
        region_id: string;
        region_name: string;
    }
    vcpu: {
        vcpu_total_count: number;
        vcpu_used_count: number;
        vcpu_percent: number;
    }
    memory: {
        mem_total_capacity_mb: number;
        mem_used_capacity_mb: number;
        mem_percent: number;
    }
    storage: {
        storage_total_capacity_mb: number;
        storage_used_capacity_mb: number;
        storage_percent: number;
    }
    gpu: {
        gpu_total_count: number;
        gpu_used_count: number;
    }
    host_clusters: HostClustersData[];
}




export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("HOST_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "HOST_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "HOST_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "HOST_SYNC",
        },
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("HOST_NAME_TEXT"),
        accessor: "host_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("vCPU"),
        accessor: "vcpu",
        disableSortBy: false,
        style: {
            width: "150px",
            paddingLeft: 20,
        },
        Cell: ({ cell: {value} }) => (
            value.vcpu_percent < 80 ?
            <div style={className.usageContainer}>
                <div style={className.usageRowContainer}>
                    <CpuImg style={className.resourceImg}/>
                    <div style={className.usageText}>{value.vcpu_total_count}cores</div>
                    <div style={className.usageCpuValue}>{value.vcpu_percent || '0'}%</div>
                </div>
                <div style={className.usageRowContainer}>
                    <CustomProgressBar key={901} width={120} height={10} colors={["#4aaaff", "#f0f3fa"]} percent={value.vcpu_percent}/>
                </div>
            </div>
            : value.vcpu_percent >= 80 && value.vcpu_percent < 90 ?
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <AlertImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <CpuImg style={className.resourceImg}/>
                            <div style={className.usageText}>{value.vcpu_total_count}cores</div>
                            <div style={className.usageWarnValue}>{value.vcpu_percent || '0'}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={901} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.vcpu_percent}/>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <ErrorImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <CpuImg style={className.resourceImg}/>
                            <div style={className.usageText}>{value.vcpu_total_count}cores</div>
                            <div style={className.usageWarnValue}>{value.vcpu_percent || '0'}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={901} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.vcpu_percent}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    },
    {
        Header: i18n.t("Memory"),
        accessor: "memory",
        disableSortBy: false,
        style: {
            width: "150px",
            paddingLeft: 20,
        },
        Cell: ({ cell: {value} }) => (
            value.mem_percent < 80 ?
            <div style={className.usageContainer}>
                <div style={className.usageRowContainer}>
                    <MemoryImg style={className.resourceImg}/>
                    <div style={className.usageText}>{(value.mem_total_capacity_mb / 1024).toFixed(1)}GB</div>
                    <div style={className.usageMemoryValue}>{value.mem_percent || '0'}%</div>
                </div>
                <div style={className.usageRowContainer}>
                    <CustomProgressBar key={902} width={120} height={10} colors={["#7560bd", "#f0f3fa"]} percent={value.mem_percent}/>
                </div>
            </div>
            : value.mem_percent >= 80 && value.mem_percent < 95 ?
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <AlertImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <MemoryImg style={className.resourceImg}/>
                            <div style={className.usageText}>{(value.mem_total_capacity_mb / 1024).toFixed(1)}GB</div>
                            <div style={className.usageWarnValue}>{value.mem_percent || '0'}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={902} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.mem_percent}/>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <ErrorImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <MemoryImg style={className.resourceImg}/>
                            <div style={className.usageText}>{(value.mem_total_capacity_mb / 1024).toFixed(1)}GB</div>
                            <div style={className.usageWarnValue}>{value.mem_percent || '0'}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={902} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.mem_percent}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    },
    {
        Header: i18n.t("GPU"),
        accessor: "gpu",
        disableSortBy: false,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            value.gpu_total_count > 0 ?
            <div style={{...className.normalTextContainer, color: "#5a7ee9"}}>
                {value.gpu_used_count + ' / ' + value.gpu_total_count}
            </div>
            : <div style={{...className.normalTextContainer, color: "#9ca3ad"}}>
                <>{i18n.t("EMPTY_TEXT")}</>
            </div>
        )
    },
    {
        Header: i18n.t("HOST_VM_COUNT_TEXT"),
        accessor: "vm_count",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value}</div>)
    },
    {
        Header: i18n.t("HOST_BELONG_TO_HOST_CLUSTER_COUNT_TEXT"),
        accessor: "host_clusters",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#3a8344"}}>{value.length}</div>)
    },
    {
        Header: i18n.t("HOST_STATE_TEXT"),
        accessor: "up_yn",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <><StatusStableImg style={className.statusImg}/>Up</> : <><StatusBlockImg style={className.statusImg}/>Down</>
                }
            </div>
        )
    },
    {
        Header: i18n.t("HOST_STATUS_TEXT"),
        accessor: "host_status_code",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, color: value === "ENA" ? "#0853fb" : "#8c8c8c"}}>
                {value === "ENA" ? 'Enabled' : 'Disabled'}
            </div>
        )
    },
    {
        Header: i18n.t("REGION_TEXT"),
        accessor: "region",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value.region_name}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value) : "-"}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value) : "-"}
            </div>
        )
    },
];

export const hostAddModalContent = {
    title: i18n.t("HOST_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <HostAdd />,
}

export const hostUpdateModalContent = {
    title: i18n.t("HOST_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            deleteButtonYn: false,
            cancelButtonYn: false,
            confirmButtonText: i18n.t("CONFIRM_TEXT")
        },
    ],
    innerComponent: <HostUpdate />,
}


const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    statusImg: {
        marginRight: 3
    },
    resourceImg: {
        width: 24,
        height: 24
    },
    usageContainer: {
        paddingLeft: 20
    },
    usageRowContainer: {
        width: "120px",
        display: "flex",
        alignItems: "center"
    },
    usageImg: {
        width: "24px",
        height: "24px",
        filter: "opacity(0.5)"
    },
    usageText: {
        fontFamily: FONT.REGULAR,
        fontSize: "10px",
        color: "#8793a3"
    },
    usageCpuValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        color: "#4aaad4"
    },
    usageMemoryValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#7560bd"
    },
    usageWarnValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        color: "#e6735c"
    },
    warnImg: {
        width: 20,
        height: 20
    }
}